import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IGradientImage } from "@vfit/shared/models";
import { ImageAtoms } from "@vfit/shared/atoms";
import { CardContainerSmall, ContentContainerSmall, Creator, Ellipse, EllipseContainer, Title, Topic } from "../../storyCard.style";
export var StoryCardSmall = function(param) {
    var title = param.title, topic = param.topic, creator = param.creator, backgroundImg = param.backgroundImg, ellipseImg = param.ellipseImg, isExternalImages = param.isExternalImages, ignoreSize = param.ignoreSize;
    var ellipseSvg = /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "30",
                cy: "30",
                r: "28.75",
                stroke: "white",
                strokeWidth: "1.5"
            }),
            ";"
        ]
    });
    return /*#__PURE__*/ _jsxs(CardContainerSmall, {
        ignoreSize: ignoreSize,
        children: [
            backgroundImg && title && /*#__PURE__*/ _jsx(ImageAtoms, {
                image: backgroundImg,
                nameCard: title,
                objectFit: "cover",
                external: isExternalImages,
                gradient: IGradientImage.GRADIENT_TOP_10
            }),
            /*#__PURE__*/ _jsxs(EllipseContainer, {
                children: [
                    ellipseSvg,
                    ellipseImg && /*#__PURE__*/ _jsxs(Ellipse, {
                        img: "#",
                        children: [
                            /*#__PURE__*/ _jsx(ImageAtoms, {
                                image: ellipseImg,
                                nameCard: "",
                                objectFit: "cover",
                                external: isExternalImages,
                                style: {
                                    position: "relative",
                                    width: "100%",
                                    height: "0",
                                    overflow: "hidden",
                                    borderRadius: "48px"
                                }
                            }),
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ContentContainerSmall, {
                children: [
                    topic && /*#__PURE__*/ _jsx(Topic, {
                        children: topic
                    }),
                    title && /*#__PURE__*/ _jsx(Title, {
                        children: title
                    }),
                    creator && /*#__PURE__*/ _jsx(Creator, {
                        children: creator
                    })
                ]
            })
        ]
    });
};
